import styled from "styled-components";

import Button from "app/components/shared/Button";
import Emojify from "app/components/shared/Emojify";
import emptyStateGradient from "app/images/analytics/emptyStateGradient.svg";

type Props = {
  heading: string;
  subheading?: string;
  emoji?: string;
  fullscreen?: boolean;
  gradient?: boolean;
  link?: string;
};

const Wrapper = styled.div<{ fullscreen?: boolean; gradient?: boolean }>`
  position: relative;
  background: ${({ gradient }) =>
    gradient ? `url(${emptyStateGradient});` : "var(--slate-100)"};
  background-size: cover;
  min-height: 320px;
  height: ${({ fullscreen }) => (fullscreen ? "100%" : "auto")};
`;

const EmptyState = ({
  heading,
  subheading,
  emoji,
  fullscreen,
  gradient,
  link,
}: Props) => (
  <Wrapper
    fullscreen={fullscreen}
    gradient={gradient}
    className="flex flex-column gap-5 justify-center items-center p-5 rounded-3 antialiased"
  >
    {emoji && (
      <Emojify
        text={emoji}
        style={{ fontSize: 38, lineHeight: 1 }}
        title={heading}
      />
    )}

    <div className="flex justify-center items-center flex-column gap-2.5">
      <h3 className="m-0 text-center text-lg" style={{ fontSize: "18px" }}>
        {heading}
      </h3>
      {subheading && (
        <p className="m-0 text-center" style={{ maxWidth: "360px" }}>
          {subheading}
        </p>
      )}

      {link && (
        <Button href={link} theme="primary">
          Learn more in Docs
        </Button>
      )}
    </div>
  </Wrapper>
);

export default EmptyState;
